import { ApiCaller } from '../../utils/api'
import { URLS } from '../../utils/url'
const state = {
  clinicCustomerNotes: []
}

const mutations = {
  SET_CLINIC_CUSTOMER_NOTES(state, payload) {
    state.clinicCustomerNotes = [].concat(payload)
  },
  ADD_NOTES(state, payload) {
    state.clinicCustomerNotes.push(payload)
  }
}

const actions = {
  async fetchClinicCustomerNotes({ state, commit, rootState }, query) {
    const response = await ApiCaller().get(URLS.CLINIC_CUSTOMER_NOTES(), { params: query })
    if (response.data) {
      commit('SET_CLINIC_CUSTOMER_NOTES', response.data.data)
    }
  },
  async fetchClinicCustomer({ state, commit, rootState }, customer_id) {
    const response = await ApiCaller().get(URLS.CLINIC_CUSTOMER(customer_id))
    if (response.data) {
      commit('SET_CLINIC_CUSTOMER_NOTES', response.data.data)
    }
  },
}

export default {
  namespaced: true,
  state, mutations, actions
}
